import { useTranslation } from 'react-i18next'
import {
    Stack,
    Typography,
    Chip,
    Button,
} from '@mui/material'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import LocalHospitalIcon from '@mui/icons-material/LocalHospital'

export type MedicalActsSectionHeaderProps = {
    count?: number
    readOnly?: boolean
    compact?: boolean
    showTitle?: boolean
    onAddClick: () => void
}

export function MedicalActsSectionHeader({
    count,
    readOnly = false,
    compact = false,
    showTitle = true,
    onAddClick,
}: MedicalActsSectionHeaderProps) {
    const { t } = useTranslation()

    if (!showTitle && readOnly) return null

    return (
        <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Stack direction="row" spacing={1} alignItems="center">
                <LocalHospitalIcon color="primary" fontSize={compact ? 'small' : 'medium'} />
                <Typography variant={compact ? 'subtitle2' : 'h6'}>
                    {t('medicalAct.section.title', { defaultValue: 'Medical Acts' })}
                </Typography>
                {count !== undefined && count > 0 && (
                    <Chip label={count} size="small" color="primary" />
                )}
            </Stack>
            {!readOnly && (
                <Button
                    startIcon={<AddCircleOutlineIcon />}
                    variant={compact ? 'text' : 'contained'}
                    size="small"
                    onClick={onAddClick}
                >
                    {t('medicalAct.section.addButton', { defaultValue: compact ? 'Add' : 'Add Act' })}
                </Button>
            )}
        </Stack>
    )
}
